import { useContext } from "react";
import CHAPTERS_QUERY from "./queries/CHAPTERS_QUERY";
import Query from "../common/Query";
import { AppContext } from "../store";
import Loading from "../common/Loading";
import { Accordion, Button, Card, Col, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Event from "./interfaces/Event";
import JoinCTA from "../common/JoinCTA";
import VolunteerCTA from "../common/VolunteerCTA";
import ShowToRole from "../common/ShowToRole";
import VRPStatus from "./components/VRPStatus";

type Role = {
  Role: string;
  RoleStartDate: string;
  RoleEndDate: string;
};

const Events = () => {
  const { state } = useContext(AppContext);
  const navigate = useNavigate();
  const lookupId =
    state.orgInfo?.emulated_lookup_id || state.orgInfo?.lookup_id;
  const loading = state.orgInfo?.loading;
  const isVolunteer = state.orgInfo?.volunteer_access;
  const isEC = state.orgInfo?.event_coordinator;
  const isFS = state.orgInfo?.field_support;
  const loadDetails = (eventId: string) => {
    navigate(`/event/`, { state: { eventId } });
  };
  const displayUpcoming = (events: Event[]) => {
    const els = events.map((u: Event) => {
      return (
        <li key={`${u.EventLookupId}-${u.EventStartDate}`}>
          <Button
            as="a"
            variant="link"
            className="p-0"
            onClick={() => loadDetails(u.EventLookupId)}
          >
            {u.EventName} {u.EventStartTime ? " at " + u.EventStartTime : ""}
          </Button>
        </li>
      );
    });
    return els.length ? (
      <ul className="list-unstyled">{els}</ul>
    ) : (
      <strong>No Upcoming Events Scheduled</strong>
    );
  };
  const displayPast = (events: Event[]) => {
    const els = events.map((p: Event) => {
      return (
        <li key={`${p.EventLookupId}-${p.EventStartDate}`}>
          <Button
            as="a"
            variant="link"
            className="p-0"
            onClick={() => loadDetails(p.EventLookupId)}
          >
            {p.EventName} {p.EventStartTime ? " at " + p.EventStartTime : ""}
          </Button>
        </li>
      );
    });
    return els.length ? (
      <ul className="list-unstyled">{els}</ul>
    ) : (
      <strong>No Past Events Found</strong>
    );
  };
  let iter = 0;
  const displayChapter = (chapter: any) => {
    const hasChapterRole = chapter.roles?.find(
      (r: Role) =>
        (r.Role === "Chapter Area Chair" ||
          r.Role === "Chapter Area Co-Chair" ||
          r.Role === "Area Co-Chairman" ||
          r.Role === "Chapter Ticket Chair") &&
        (!r.RoleEndDate || new Date(r.RoleEndDate) > new Date())
    );
    return (
      <Card key={`${chapter.Group}-${iter++}`} className="mb-3">
        <Card.Body>
          <Card.Title>
            {chapter.GroupType}: {chapter.Group}
          </Card.Title>
          <Row>
            <Col className="col-12 col-md-6 col-lg-4 mb-4">
              {chapter.roles?.length ? (
                <>
                  <h6 className="mt-2">Your Roles</h6>
                  <ul>
                    {chapter.roles.map((r: typeof chapter.Role, i: number) => (
                      <li key={i}>
                        {r.Role}{" "}
                        <small>
                          ({r.RoleStartDate}-
                          {r.RoleEndDate ? r.RoleEndDate : "Present"})
                        </small>
                      </li>
                    ))}
                  </ul>
                </>
              ) : null}
              
              <VRPStatus chapterId={chapter.GroupID} />

              <div>
                {chapter.PrimaryContact === "Yes" ? (
                  <strong>Primary Contact</strong>
                ) : null}
              </div>
              {hasChapterRole ? (
                <Link
                  className="btn btn-success btn-sm my-3"
                  to={`/chapter/${chapter.GroupID}/${encodeURIComponent(
                    chapter.Group
                  )}`}
                >
                  Manage Volunteers
                </Link>
              ) : (
                <ShowToRole allowedRoles={["Staff"]}>
                  <Link
                    className="btn btn-success btn-sm my-3"
                    to={`/chapter/${chapter.GroupID}/${encodeURIComponent(
                      chapter.Group
                    )}`}
                  >
                    Manage Volunteers
                  </Link>
                </ShowToRole>
              )}
            </Col>
            <Col className="col-12 col-md-6 col-lg-8">
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Upcoming Events</Accordion.Header>
                  <Accordion.Body>
                    {displayUpcoming(chapter.upcoming)}
                  </Accordion.Body>
                </Accordion.Item>

                <Accordion.Item eventKey="1">
                  <Accordion.Header>Past Events</Accordion.Header>
                  <Accordion.Body>{displayPast(chapter.past)}</Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    );
  };
  const displayChapters = (chapters: any[]) => {
    if (chapters.length) {
      return chapters.map((c) => displayChapter(c));
    } else {
      return (
        <span>
          You have active volunteer status, but no events are assigned to you.
          Please email <a href="mailto:wbond@ducks.org">wbond@ducks.org</a> or
          call <a href="tel:9017583918">901-758-3918</a> for assistance.
        </span>
      );
    }
  };
  if (lookupId) {
    if (!isVolunteer && !isEC && !isFS) {
      return <VolunteerCTA />;
    } else {
      return (
        <>
          <Query variables={{ lookupId }} query={CHAPTERS_QUERY}>
            {({ data: { chapters } }: { data: { chapters: any } }) => {
              return displayChapters(chapters);
            }}
          </Query>
        </>
      );
    }
  } else {
    if (loading) {
      return <Loading />;
    } else {
      return <JoinCTA />;
    }
  }
};

export default Events;
